import { lazy } from 'react';
// @ts-ignore
export const CreateScreenAsync = lazy(() => import('./CreateScreen.tsx'));
